import { useOrderChanges } from '@hooks';
import { Order } from '@services';
import { observer } from 'mobx-react';
import { OrderChangeList } from './OrderChangeList';

interface IProps {
  order: Order;
}

export const OrderChangeShared: React.FC<IProps> = observer(({ order }) => {
  const { orderChanges } = useOrderChanges(order);
  return <OrderChangeList changes={orderChanges} />;
});

